import styled from 'styled-components';
import { fontDisplay, fontUi } from '../../theme/typography';

export const StyledHero = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 112px;
  margin-bottom: 24px;
  padding: 22px 28px;
  border-radius: ${({ theme }) => theme.cardRadius};
  background: #000;
  overflow: visible;
  box-sizing: border-box;

  @media only screen and (max-width: 768px) {
    min-height: 96px;
    padding: 16px 18px;
    flex-wrap: wrap;
  }
`;

export const StyledHeroPhoto = styled.div`
  position: absolute;
  inset: 0;
  overflow: hidden;
  border-radius: ${({ theme }) => theme.cardRadius};
  pointer-events: none;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.65;
  }
`;

export const StyledHeroCopy = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;

  h1 {
    ${fontDisplay};
    margin: 0;
    display: flex;
    align-items: center;
    gap: 8px;
    color: #fff;
    font-size: 32px;
    letter-spacing: -0.02em;
    @media only screen and (max-width: 768px) {
      font-size: 24px;
    }
    svg {
      flex-shrink: 0;
    }
  }

  p {
    ${fontUi};
    margin: 0;
    color: rgba(255, 255, 255, 0.55);
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }
`;
